import { AMPLITUDE_EVENTS } from 'amplitude/events'
import { track, logEvent } from '@amplitude/analytics-browser'
import { useAppState } from 'store'

const env = process.env.REACT_APP_ENVIROMENT

type AmplitudeEventProperties = {
  user_id?: number
  location?: string | number
  modal?: string
  appointment_date?: string
  appointment_time?: string
  client_id?: string
}

type AmplitudeReturn = {
  logEvent: (
    event: AMPLITUDE_EVENTS,
    properties?: AmplitudeEventProperties
  ) => void
}

export const useAmplitude = (): AmplitudeReturn => {
  const { user } = useAppState(state => state.auth)
  const amplitudeDefaultProperties = {
    environment: env,
    user_id: user?.id,
  }

  const logEvent = (
    event: AMPLITUDE_EVENTS,
    properties?: AmplitudeEventProperties
  ) => {
    const props = Object.assign(amplitudeDefaultProperties, properties)
    track(event, props)
  }

  return { logEvent }
}
